// extracted by mini-css-extract-plugin
export default {"background":"TrainingPageWrapper_background__+Q0bw"};